import { render, staticRenderFns } from "./OrderTable.vue?vue&type=template&id=58c9ff9c&scoped=true"
import script from "./OrderTable.vue?vue&type=script&lang=ts"
export * from "./OrderTable.vue?vue&type=script&lang=ts"
import style0 from "./OrderTable.vue?vue&type=style&index=0&id=58c9ff9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c9ff9c",
  null
  
)

export default component.exports